<template>
  <div class="navegationTable" :class="dark_t?'dark':''">
    <div>
      <div class="range" style="margin-right: 15px" v-if="rows_x_page">
        <div style="display: inline-block;">Filas por pagina</div>
        <v-select
          :menu-props="{ top: true, offsetY: true }"
          style="display: inline-block;margin-left:20px;width: min-content;"
          v-model="selectedItem.page_size"
          :items="rowsXpage"
          item-text="t"
          item-value="v"/>
      </div>
      <div class="range">
        <span>{{navegationRange}}</span>
      </div>
      <div>
        <button @click="pageChange(selectedItem.page - 1)"
          :disabled="selectedItem.page <= 1"
          class="v-btn v-btn--flat v-btn--icon theme--light"
          :class="selectedItem.page <= 1 &&  'v-btn--disabled'">
          <v-icon>keyboard_arrow_left</v-icon>
        </button>
        <div style="width:25px;display:inline-block"></div>
        <button @click="pageChange(selectedItem.page + 1)"
          class="v-btn v-btn--flat v-btn--icon theme--light"
          :class="selectedItem.page >= selectedItem.pages &&  'v-btn--disabled'"
          :disabled="selectedItem.page >= selectedItem.pages">
          
          <v-icon>keyboard_arrow_right</v-icon>
        </button>
      </div>						
    </div>
  </div>
</template>

<script>
const SHOW_ALL_PAGE_SIZE = 10000;

export default {
  props:{
    selectedItem:{},
    pageChange:{
      default:()=>{return function(){}}
    },
    rows_x_page:{ default:true },
  },
  computed: {
    rowsXpage() {
      return [
        {v: 10, t: 10},
        {v: 25, t: 25},
        {v: SHOW_ALL_PAGE_SIZE, t: 'Todas'},
      ];
    },
    navegationRange(){
      const page = this.selectedItem.page || 1;
      const pageSize = this.selectedItem.page_size || 10;
      const count = this.selectedItem.count || 0;
      if (!count) return `0 - 0 de 0`;
      const start = (page - 1) * pageSize + 1;
      const end = Math.min(page * pageSize, count);
      return `${start} - ${end} de ${count}`;
    },
  },
};
</script>
